// extracted by mini-css-extract-plugin
export default {"AggregateLabels":"parent-issue-group-header-label-module__AggregateLabels__xQobXZ7","ParentIssueTitle":"parent-issue-group-header-label-module__ParentIssueTitle__Zvdmmdr"};